import {
  Box,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  TableRow,
  TableCell,
  Collapse,
  IconButton,
  TableContainer,
  Paper,
  TableHead,
  TableBody,
  Table,
  Dialog,
  CircularProgress,
  Checkbox,
  ListItemText,
  Divider,
  Button,
  DialogContent,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@material-ui/core";
import { Clear, Refresh } from "@material-ui/icons";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import { appUrl } from "../../../../../utils/config";
import React, { useEffect, useState,useRef } from "react";
import jwtDecode from "jwt-decode";
import POLineChat from "./ChatPOLine/POLineChat";
// import StatusTab from "./statusTab";
import axios from "axios";
import DetailView from "./detailView";
import CustomDialogTitle from "../../common/projectsDashboard/CustomDialogTitle";
import StatusTab from "./StatusTab";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AverageOTIFTrend from "../poFulfilmentDashboard/averageOTIFTrend";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import PaginationInput from "../../common/models/pagination/PaginationInput";
import ClearIcon from "@material-ui/icons/Clear";
import Block from "./QuickSummary/Block";
import clsx from "clsx";
import StyledButton from "../../../../common/models/Button";
import { Autocomplete } from "@material-ui/lab";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import BackDropLoading from "../../common/models/BackDrop";
import StyledDialog from "../../../../common/models/Dialog";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import { fetchPurchaseOrdersFilters } from "../../../containers/actions/common/purchaseOrderAction";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #000000de",
    borderRadius: "0.5rem",
    padding: "0.3rem",
    width: "20px",
    height: "20px",
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  logoHeight: {
    height: "inherit",
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "2.8rem",
    paddingRight: "2.8rem",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
  dpFlx: { display: "flex" },
  algnCntr: { alignItems: "center" },
  pointer: { cursor: "pointer" },
  onHvrUndrline: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  BtnSty: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid black",
    },
  },
  inputBaseRoot: {
    padding: "0px",
    paddingRight: "14px",
    height: "40px",
  },
  accordionSummary: {
    "&.Mui-expanded": {
      minHeight: "50px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "10px 0px",
    },
  },
}));

export default function PoFulfilmentDashboard(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { deliveryCompletionIndicator, savedFilter, featuresAccess } = props;

  const [searchField, setSearchField] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [searchSelectValue, setSearchSelectValue] = useState(null);
  const [vendorMosymphonyID, setVendorMosymphonyID] = useState("0");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
  const [totalPages, setTotalPages] = useState(1);
  const [expanded, setExpanded] = useState(false);
  const [filterByDate, setFilterByDates] = useState("0");
  const [otifRange, setOtifRange] = useState("All");
  // const [committedDateRangeNumber, setCommittedDateRangeNumber] = useState(-30)
  const [open, setOpen] = useState({}); //dropdown
  const [lineItems, setLineItems] = useState(null); //api data
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const tokenData = jwtDecode(localStorage.getItem("authToken"));
  const [vendorPlant, setVendorPlant] = useState(null);
  const [rowData, setRowData] = useState({});
  const [openDialogBox, setDialogBox] = useState({
    detailView: false,
  });
  const history = useHistory();
  const [plantList, setPlantList] = useState([]);
  const [plannerList, setPlannerList] = useState([]);
  const [selectedPlantIdList, setSelectedPlantIdList] = useState([]);
  const [SelectedCMOList, setSelectedCMOList] = useState([]);
  const [selectedPlannerList, setSelectedPlannerList] = useState([]);
  const [filteredPlantList, setFilteredPlantList] = useState([]);
  const [filteredVendorMosymphonyIDList, setFilteredVendorMosymphonyIDList] =
    useState([]);
  const [filteredPlannerList, setFilteredPlannerList] = useState([]);
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [plantIdOptions, setPlantIdOptions] = useState([]);
  const [plannerOptions, setPlannerOptions] = useState([]);
  
  // let pageLoaded = useRef(false);
  // let timeoutId = useRef(null);

  const [supplyTypes, setSupplyTypes] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [plantTypes, setPlantTypes] = useState([]);
  // const [savedFilter, setSavedFilter] = useState(null);
  const [quickSummary, setQuickSummary] = useState({
    loading: false,
    data: null,
  });

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (val) => {
    setCurrentPage(val);
  };

  const handleOpenCloseDialogBox = (type, item) => {
    if (type === "detailView") {
      setDialogBox({
        detailView: !openDialogBox.detailView,
      });
      setRowData(item);
    }
  };

  useEffect(() => {
    setSelectedPlantIdList(
      savedFilter?.plantListFilter &&
        Array.isArray(savedFilter?.plantListFilter)
        ? savedFilter?.plantListFilter
        : []
    );
    setSelectedCMOList(
      savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
        ? savedFilter?.cmoListFilter
        : []
    );
    setSelectedPlannerList(
      savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
        ? savedFilter?.plannerUserId
        : []
    );

    // let filteredPlannerList = savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
    // ? savedFilter?.plannerUserId
    //   : []

    let filteredCMOList =
      savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
        ? savedFilter?.cmoListFilter
        : [];

    // filteredPlannerList.forEach((val) => {
    //     if (plannerOptions.filter((val1) => val1.saasUserID === val).length > 0) {
    //       let orgIds = plannerOptions.filter((val1) => val1.saasUserID === val)[0].organization_ids
    //       filteredCMOList = [...new Set([...orgIds, ...filteredCMOList])];
    //     }
    //   })

    setFilterByDates(
      deliveryCompletionIndicator
        ? savedFilter?.deliveryDateRange
          ? savedFilter?.deliveryDateRange
          : "0"
        : savedFilter?.committedDateRange
        ? savedFilter?.committedDateRange
        : "0"
    );

    setFilteredPlantList(
      savedFilter?.plantListFilter &&
        Array.isArray(savedFilter?.plantListFilter)
        ? savedFilter?.plantListFilter
        : []
    );
    setFilteredVendorMosymphonyIDList(filteredCMOList);

    setFilteredPlannerList(
      savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
        ? savedFilter?.plannerUserId
        : []
    );
  }, [savedFilter, plannerOptions]);

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, [])
  useEffect(() => {
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypesDirect/true`
      )
      .then((res) => {
        //console.log(res.data?.data?.status);
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.supplyTypeList);
          setSupplyTypes(
            res.data?.data?.supplyTypeList ? res.data?.data?.supplyTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypesDirect/true`
      )
      .then((res) => {
        //console.log(res.data?.data?.status);
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.drugTypeList);
          setDrugTypes(
            res.data?.data?.drugTypeList ? res.data?.data?.drugTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantTypesDirect/true`
      )
      .then((res) => {
        //console.log(res.data?.data?.status);
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.plantTypeList);
          setPlantTypes(
            res.data?.data?.plantTypeList ? res.data?.data?.plantTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    // axios
    //   .get(
    //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllVendorPlants`
    //   )
    //   .then((res) => {
    //     console.log(res.data?.status);
    //     if (res.data?.status) {
    //       console.log(res.data?.vendorPlantDetails);
    //       setPlantList(
    //         res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
    //       );
    //       setPlantIdOptions(
    //         res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
    //       );
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
  .get(
    `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDsDirect/all`
  )
  .then((res) => {
    //console.log("res is here shekar for new api", res);
    if (isMounted.current && res.data?.vendorOrgLevelData) {
      // Flatten receivingPlantIDs from all vendorOrgLevelData objects
      const plantIds = res.data.vendorOrgLevelData
        .flatMap((item) => item.receivingPlantIDs || [])
        .filter((id) => id); // Remove null/undefined
      // Map to the format expected by plantList and plantIdOptions
      const formattedPlants = plantIds.map((id) => ({
        plantCode: id,
        vendorMosymphonyID: res.data.vendorOrgLevelData.find((item) =>
          item.receivingPlantIDs.includes(id)
        )?.vendorMosymphonyID,
        // supplyTypeName: supplyTypes.find(st => st.supplyTypeID === id)?.supplyTypeName || "",
        // drugTypeName: drugTypes.find(dt => dt.drugTypeID === id)?.drugTypeName || "",
        // plantTypeName: plantTypes.find(pt => pt.plantTypeID === id)?.plantTypeName || ""
      }));
      setPlantList(formattedPlants);
      setPlantIdOptions(formattedPlants);
     // console.log("Receiving Plant IDs (vendorMosymphonyID = 'all'):", formattedPlants);
    } else if (isMounted.current) {
      //console.warn("No vendorOrgLevelData received from fetchAllReceivingPlantIDsAndStorageLocationIDs");
      setPlantList([]);
      setPlantIdOptions([]);
    }
  })
  .catch((err) => {
    if (isMounted.current) {
      console.error(
        "Error fetching receiving plant IDs and storage locations for vendorMosymphonyID = 'all':",
        err
      );
      setPlantList([]);
      setPlantIdOptions([]);
    }
  });

    axios
      .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlannerDetailsDirect`)
      .then((res) => {
        if (res.data?.status) {
          setPlannerOptions(res.data?.data ? res.data?.data : []);
          setPlannerList(res.data?.data ? res.data?.data : []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  //useEffect
  useEffect(() => {
    setLoading(true);

    let data = {
      searchField: searchField === "all" ? "" : searchField,
      searchValue: searchValue,
      // vendorMosymphonyID: parseInt(vendorMosymphonyID),
      brandOwnerMosymphonyID: tokenData.organization_id,
      committedDateRange: deliveryCompletionIndicator
        ? ""
        : filterByDate !== "0"
        ? filterByDate
        : "",
      deliveryDateRange: deliveryCompletionIndicator
        ? filterByDate !== "0"
          ? filterByDate
          : ""
        : "",
      deliveryCompletionIndicator: deliveryCompletionIndicator,
      plantCodeList: filteredPlantList,
      vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
      otifRange: otifRange,
      // plantID: vendorPlant,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      // plannerEmailIDs: filteredPlannerList.map(id => {
      //   const planner = plannerOptions.find(p => p.saasUserID === id);
      //   return planner ? planner.email : null;
      // }).filter(email => email !== null),
      //plannerSaasUserIDs: filteredPlannerList,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOFulfilmentDashboard`,
        data
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setLineItems(res.data.data);
          setTotalPages(res.data.data.numberOfPages);
          setError(null);
        } else {
          setLineItems(null);
          setError(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setError(err.message);
      });

    setQuickSummary({
      ...quickSummary,
      loading: true,
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchQuickSummaryPOFulfilment`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          setQuickSummary({
            loading: false,
            data: res.data.data,
          });
          setError(null);
        } else {
          setQuickSummary({
            loading: false,
            data: null,
          });
          setError(null);
        }
      })
      .catch((err) => {
        setQuickSummary({
          loading: false,
          data: null,
        });
        console.error(err);
      });
  }, [
    vendorMosymphonyID,
    filterByDate,
    otifRange,
    refresh,
    rowsPerPage,
    currentPage,
    filteredPlantList,
    filteredVendorMosymphonyIDList,
    deliveryCompletionIndicator,
    filteredPlannerList,
  ]);

  const handleSearchField = (event) => {
    // setCurrentPage(1);
    setSearchField(event.target.value);
    setSearchValue("");
    setSearchSelectValue(null);
  };

  function handleClearSearch() {
    if (["Supply type", "Drug type", "Plant type"].includes(searchField)) {
      if (SelectedCMOList.length > 0) {
        setPlantList(
          plantIdOptions.filter((val) =>
            SelectedCMOList.includes(val.vendorMosymphonyID)
          )
        );
      } else {
        setPlantList(plantIdOptions);
      }
    }
    setSearchValue("");
    setLoading(true);
    setSearchSelectValue(null);
    const data = {
      // searchField: searchField === "all" ? "" : searchField,
      // searchValue: "",
      searchField: "",
      searchValue: "",
      vendorMosymphonyID: parseInt(vendorMosymphonyID),
      brandOwnerMosymphonyID: tokenData.organization_id,
      committedDateRange: deliveryCompletionIndicator
        ? ""
        : filterByDate !== "0"
        ? filterByDate
        : "",
      deliveryDateRange: deliveryCompletionIndicator
        ? filterByDate !== "0"
          ? filterByDate
          : ""
        : "",
      deliveryCompletionIndicator: deliveryCompletionIndicator,
      plantCodeList: filteredPlantList,
      vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
      otifRange: otifRange,
      plantID: vendorPlant,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      //plannerSaasUserIDs: filteredPlannerList
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOFulfilmentDashboard`,
        data
      )
      .then((res) => {
        // throw new Error("Mock Error");
        setLoading(false);
        if (res.data.status) {
          setLineItems(res.data.data);
          setTotalPages(res.data.data.numberOfPages);
          setError(null);
        } else {
          setLineItems(null);
          setError(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setError(err.message);
      });
  }
  const handleRowToggle = (index) => {
    setOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  function handleSearchValue(e) {
    setSearchValue(e.target.value);
  }

  function handleSearchClick() {
    setRefresh(!refresh);
    setCurrentPage(1);
    setError(null);
    let plantArray = filteredPlantList;
    if (
      searchField === "Supply type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.supplyTypeName === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
      if (selectedPlantIdList.length > 0) {
        setSelectedPlantIdList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
        setFilteredPlantList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
      } else {
        setFilteredPlantList(plantArray);
      }
    } else if (
      searchField === "Drug type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.drugTypeName === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
      if (selectedPlantIdList.length > 0) {
        setSelectedPlantIdList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
        setFilteredPlantList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
      } else {
        setFilteredPlantList(plantArray);
      }
    } else if (
      searchField === "Plant type" &&
      (searchValue !== "" || searchValue === null)
    ) {
      let type = plantIdOptions.filter(
        (val) => val.plantTypeName === parseInt(searchValue)
      );
      plantArray = type.map((val) => val.plantCode);
      setPlantList(type);
      if (selectedPlantIdList.length > 0) {
        setSelectedPlantIdList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
        setFilteredPlantList(
          selectedPlantIdList.filter((value) => plantArray.includes(value))
        );
      } else {
        setFilteredPlantList(plantArray);
      }
    }
  }

  function handleClearFilters() {
    setSearchField("all");
    setSearchValue("");
    setFilterByDates("0");
    setVendorMosymphonyID("0");
    setOtifRange("All");
    setCurrentPage(1);
    setSearchSelectValue(null);
    setSelectedCMOList([]);
    setSelectedPlantIdList([]);
    setSelectedPlannerList([]);
    setFilteredPlantList([]);
    setFilteredVendorMosymphonyIDList([]);
    setFilteredPlannerList([]);
  }
  function handleFilterByDates(e) {
    setFilterByDates(e.target.value);
    setCurrentPage(1);
    setError(null);
  }
  function handleFilterByCMO(e) {
    //   const selectedCMO = e.target.value;
    //   console.log("Selected CMO", selectedCMO);

    //   if (selectedCMO.vendorPlant) {
    //     setVendorPlant(selectedCMO.vendorPlant);
    //   } else setVendorPlant(null);
    //   setVendorMosymphonyID(selectedCMO.organization_id);
    // }
    // console.log("vendor:", vendorPlant);

    const selectedValue = e.target.value;
    //console.log("Selected CMO:", selectedValue);
    setVendorMosymphonyID(selectedValue);
    // Find the selected CMO details
    const selectedCMO = cmoMemberWithId.find(
      (cmo) => cmo.organization_id === parseInt(selectedValue)
    );
    if (selectedCMO) {
      if (selectedCMO.vendorPlant) {
        setVendorPlant(selectedCMO.vendorPlant);
      } else {
        setVendorPlant(null);
      }
      setVendorMosymphonyID(selectedCMO.organization_id);
    }
    setCurrentPage(1);
    setError(null);
  }
  const handleRefresh = () => {
    setRefresh(!refresh);
    setError(null);
  };

  function getChipColor(percentage) {
    switch (percentage) {
      case "Upto 70":
        return "#ff0000"; // Red color for "Upto 70"
      case "70 to 90":
        return "#e78a00"; // Orange color for "70 to 90"
      case "90+":
        return "#329429"; // Green color for "90+"
      default:
        return "#000000"; // Default color if none of the cases match
    }
  }

  const handleChangeCMOList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedCMOList(
        SelectedCMOList.length === cmoMemberWithId.length
          ? []
          : cmoMemberWithId.map((val) => val.organization_id)
      );
      setPlantList(
        plantIdOptions.filter((val) =>
          cmoMemberWithId
            .map((val) => val.organization_id)
            .includes(val.vendorMosymphonyID)
        )
      );
      setPlannerList(
        plannerOptions.filter((val) =>
          val?.organization_ids
            ? val.organization_ids.some((item) =>
                cmoMemberWithId.map((val) => val.organization_id).includes(item)
              )
            : false
        )
      );
    } else {
      setSelectedCMOList(value);
      if (value.length > 0) {
        setPlantList(
          plantIdOptions.filter((val) => value.includes(val.vendorMosymphonyID))
        );
        setPlannerList(
          plannerOptions.filter((val) =>
            val?.organization_ids
              ? val?.organization_ids.some((item) => value.includes(item))
              : false
          )
        );
      } else {
        setPlantList(plantIdOptions);
        setPlannerList(plannerOptions);
      }

      if (selectedPlantIdList.length > 0 && value.length > 0) {
        setSelectedPlantIdList(
          selectedPlantIdList.filter((val) => {
            const match = plantIdOptions.find((val1) => val === val1.plantCode);
            return match ? value.includes(match.vendorMosymphonyID) : false;
          })
        );
      }
    }
  };

  const handleClick = () => {
    history.push(
      "/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/averageOTIFReport",
      { deliveryCompletionIndicator: deliveryCompletionIndicator }
    );
  };

  const getDisplayCMOFilterValue = () => {
    if (
      SelectedCMOList.length === cmoMemberWithId.length &&
      SelectedCMOList.length !== 1
    )
      return "All";
    else if (
      SelectedCMOList.length === cmoMemberWithId.length &&
      SelectedCMOList.length === 1
    ) {
      let result = cmoMemberWithId.filter(
        (val) => SelectedCMOList[0] == val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    } else if (SelectedCMOList.length === 1) {
      let result = cmoMemberWithId.filter(
        (val) => SelectedCMOList[0] == val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const handleChangePlantIdList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedPlantIdList(
        selectedPlantIdList.length === plantList.length
          ? []
          : plantList.map((val) => val.plantCode)
      );
    } else {
      setSelectedPlantIdList(value);
    }
  };

  const getDisplayPlantIDValue = () => {
    if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length !== 1
    )
      return "All";
    else if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length === 1
    ) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] == val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    } else if (selectedPlantIdList.length === 1) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] == val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const handleChangePlannerList = (event) => {
    const value = event.target.value;
    //console.log(value);

    if (value.includes("All")) {
      setSelectedPlannerList(
        selectedPlannerList.length === plannerList.length
          ? []
          : plannerList.map((val) =>val.saasUserID)
      );
    } else {
      setSelectedPlannerList(value);
    }
  };

  const getDisplayPlannerValue = () => {
    if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length !== 1
    )
      return "All";
    else if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length === 1
    ) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] == val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    } else if (selectedPlannerList.length === 1) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] == val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const handleSaveFilter = () => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...",
    });

    let data = {
      ...savedFilter,
      cmoListFilter: SelectedCMOList,
      plantListFilter: selectedPlantIdList,
      plannerUserId: selectedPlannerList,
      committedDateRange: deliveryCompletionIndicator
        ? savedFilter.committedDateRange
        : filterByDate,
      deliveryDateRange: deliveryCompletionIndicator
        ? filterByDate
        : savedFilter.deliveryDateRange,
    };
    axios
      .post(`${appUrl}/user/saveDashboardFilters`, data)
      .then((res) => {
        // throw new Error("Mock Error");
        dispatch({
          type: DESTROY_BACKDROP,
        });
        //console.log(res);
        dispatch(fetchPurchaseOrdersFilters());
        setSavedSuccessfull(true);
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSaveFailed(true);
      });

    // setTimeout(() => {
    //   console.log()
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //                     // setmainError('Something went wrong. Please try again.')
    //                     // errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //   // setSavedSuccessfull(true);
    //   // setSaveFailed(true)
    //         }, 3000)

    // setFilteredPlantList(selectedPlantIdList.length > 0
    //   ? selectedPlantIdList
    //   : SelectedCMOList.length > 0
    //     ? plantList.filter((val) => SelectedCMOList.includes(val.vendorMosymphonyID)).map((val) => val.plantCode)
    //     : []);
    // setFilteredVendorMosymphonyIDList(SelectedCMOList);
  };

  const handleCloseSave = () => {
    setSavedSuccessfull(false);
  };

  const handleSelectChangeListLosesFocus = (type) => {
    //console.log(SelectedCMOList);
    if (type === "cmo") {
      setFilteredVendorMosymphonyIDList(SelectedCMOList);
      setFilteredPlantList(
        selectedPlantIdList.length > 0 ? selectedPlantIdList : []
      );
      // setFilteredPlantList(
      //   selectedPlantIdList.length > 0
      //     ? selectedPlantIdList
      //     : SelectedCMOList.length > 0
      //     ? plantList
      //         .filter((val) => SelectedCMOList.includes(val.vendorMosymphonyID))
      //         .map((val) => val.plantCode)
      //     : []
      // );
    } else if (type === "plantID") {
      setFilteredPlantList(
        selectedPlantIdList.length > 0 ? selectedPlantIdList : []
      );
      // setFilteredPlantList(
      //   selectedPlantIdList.length > 0
      //     ? selectedPlantIdList
      //     : SelectedCMOList.length > 0
      //     ? plantList
      //         .filter((val) => SelectedCMOList.includes(val.vendorMosymphonyID))
      //         .map((val) => val.plantCode)
      //     : []
      // );
    } else if (type === "planner") {
      setFilteredPlannerList(
        selectedPlannerList.length > 0 ? selectedPlannerList : []
      );
      // if (SelectedCMOList.length > 0) {
      //   setFilteredVendorMosymphonyIDList(SelectedCMOList)
      // } else {
      //     let cmoList = []
      //     selectedPlannerList.forEach((val) => {
      //       if (plannerList.filter((val1) => val1.saasUserID === val).length > 0) {
      //         let orgIds = plannerList.filter((val1) => val1.saasUserID === val)[0].organization_ids
      //       cmoList = [...new Set([...orgIds, ...cmoList, ...SelectedCMOList])];
      //       }
      //     })
      //     setFilteredVendorMosymphonyIDList(cmoList)
      // }
    }
  };

  //   const tableData = lineItems?.slDetailsList;

  //   let totalPages1 = Math.ceil(tableData.length / rowsPerPage);

  //   let records = currentPage * rowsPerPage;

  //   const tableDataView = projectTable
  //   ? formatData(projectTable.slice(records - rowsPerPage, records))
  // : []

  return (
    <React.Fragment>
      <BackDropLoading />
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          {/* DropDown and Search */}
          <Grid
            spacing={2}
            container
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Grid item>
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: "end",
                }}
              >
                <Grid
                  item
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // justifyContent:'flex-start',
                    // width: '30rem',
                  }}
                >
                  {/* Dropdown inside search bar for selecting field (e.g., COI, Treating Hospitals) */}
                  <Box
                    style={{
                      width: "30rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="select-search-by-field"
                  >
                    <TextField
                      size="small"
                      select
                      value={searchField}
                      variant="outlined"
                      onChange={handleSearchField}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleSearchField()
                      }
                      style={{
                        minWidth: 30,
                        border: "1px solid black",
                        borderRight: "none",
                        borderRadius: "0.1rem",
                        backgroundColor: "#F0F0F0",
                      }}
                      className="select-search"
                    >
                      <MenuItem value="all">Select search by</MenuItem>
                      <MenuItem value="PO number">PO Number</MenuItem>
                      <MenuItem value="Product code">Product Code</MenuItem>
                      <MenuItem value="Product description">
                        Product description
                      </MenuItem>
                      <MenuItem value="Plant ID">Plant ID</MenuItem>
                      <MenuItem value="Supply type">Supply type</MenuItem>
                      <MenuItem value="Drug type">Drug type</MenuItem>
                      <MenuItem value="Plant type">Plant type</MenuItem>
                    </TextField>

                    {!["Supply type", "Drug type", "Plant type"].includes(
                      searchField
                    ) && (
                      <TextField
                        size="small"
                        value={searchValue}
                        className="search-textbox"
                        // onChange={(e) => setSearchValue(e.target.value)}
                        disabled={searchField === "all"}
                        onChange={(e) => {
                          if (searchField !== "all") {
                            handleSearchValue(e);
                          }
                        }} // Update search value on input
                        onBlur={(e) => {
                          const { value } = e.target;
                          // Trim leading and trailing spaces for string values
                          if (typeof value === "string" && value.trim() !== value) {
                            const trimmedValue = value.trim();
                            if (searchField !== "all") {
                              const syntheticEvent = {
                                target: {
                                  value: trimmedValue,
                                },
                              };
                              handleSearchValue(syntheticEvent);
                            }
                          }
                        }}
                        onKeyDown={(e) =>
                          e.key === "Enter" && handleSearchClick()
                        } // Call API on Enter key
                        variant="outlined"
                        placeholder="Search"
                       
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end"> 
                              {searchValue && (
                                <Tooltip
                                  title="Clear search"
                                  aria-label="clear"
                                >
                                  <Clear
                                    fontSize="small"
                                    onClick={handleClearSearch} // Clear search value
                                    style={{
                                      cursor: "pointer",
                                      color: "dimgray",
                                    }}
                                  />
                                </Tooltip>
                              )}
                              <IconButton
                                size="small"
                                style={{
                                  backgroundColor: "#EB5E28",
                                  color: "white",
                                  borderTopRightRadius: "4px",
                                 //width: 400
    borderBottomRightRadius: "4px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
                                  padding: "8px",
                                  translate: "0.84rem",
                                  marginLeft: "0px",
                                  marginRight: "-1px",
                                
                                }}
                                onClick={handleSearchClick} // Trigger API call on click
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        style={{
                          width: "100%",
                          flex: 1,
                          border: "1px solid black",
                          borderRadius: "0.1rem",
                        }}
                      />
                    )}

                    {["Supply type", "Drug type", "Plant type"].includes(
                      searchField
                    ) && (
                      <Autocomplete
                        options={
                          searchField === "Supply type"
                            ? supplyTypes
                            : searchField === "Drug type"
                            ? drugTypes
                            : searchField === "Plant type"
                            ? plantTypes
                            : []
                        }
                        getOptionLabel={(option) => {
                          if (searchField === "Supply type") {
                            return option.supplyTypeName;
                          } else if (searchField === "Drug type") {
                            return option.drugTypeName;
                          } else {
                            return option.plantTypeName;
                          }
                        }}
                        value={searchSelectValue || null}
                        onChange={(e, value) => {
                          if (searchField !== "all") {
                            setSearchSelectValue(value);
                            if (typeof value === "object") {
                              setSearchValue(
                                searchField === "Supply type"
                                  ? String(value.supplyTypeID)
                                  : searchField === "Drug type"
                                  ? String(value.drugTypeID)
                                  : searchField === "Plant type"
                                  ? String(value.plantTypeID)
                                  : null
                              );
                            } else {
                              setSearchValue("");
                            }
                          }
                        }}
                        style={{
                          width: "100%",
                          flex: 1,
                          border: "1px solid black",
                          borderRadius: "0.1rem",
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            value={searchValue}
                            variant="outlined"
                            placeholder="Search"
                            onChange={(e) => {
                              if (searchField !== "all") {
                                handleSearchValue(e);
                              }
                            }}
                            InputProps={{
                              ...params.InputProps,
                              className: classes.inputBaseRoot,
                              endAdornment: (
                                <InputAdornment position="end">
                                  {searchValue && (
                                    <Tooltip
                                      title="Clear search"
                                      aria-label="clear"
                                    >
                                      <Clear
                                        fontSize="small"
                                        onClick={handleClearSearch} // Clear search value
                                        style={{
                                          cursor: "pointer",
                                          color: "dimgray",
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                  <IconButton
                                    size="small"
                                    style={{
                                      backgroundColor: "#EB5E28",
                                      color: "white",
                                      borderRadius: "0",
                                      padding: "8px",
                                      translate: "0.84rem",
                                    }}
                                    onClick={handleSearchClick} // Trigger API call on click
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )} // Disable until PO is selected
                      />
                    )}
                  </Box>
                </Grid>

                <Grid
                  item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Grid>
                    <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                      {deliveryCompletionIndicator
                        ? "Delivery date:"
                        : "Committed date range:"}
                    </Typography>
                  </Grid>

                  <Grid>
                    <FormControl
                      variant="outlined"
                      size="small"
                      style={{ width: "13rem", marginRight: "2rem" }}
                      className="dashboard-filter-dropdown"
                    >
                      <TextField
                        size="small"
                        select
                        variant="outlined"
                        placeholder="Choose option"
                        className={classes.textfieldWidth}
                        onChange={handleFilterByDates}
                        value={filterByDate}
                      >
                        {/* <MenuItem value='all'>All</MenuItem>
                  <MenuItem value='startingMaterial'>
                    Starting Material
                  </MenuItem>  */}
                        <MenuItem value="0">All</MenuItem>
                        {(!deliveryCompletionIndicator
                          ? [
                              { value: "Last 30 days", label: "Last 30 days" },
                              { value: "Next 15 days", label: "Next 15 days" },
                              { value: "Next 30 days", label: "Next 30 days" },
                              { value: "Next 60 days", label: "Next 60 days" },
                            ]
                          : [
                              { value: "Last 7 days", label: "Last 7 days" },
                              { value: "Last 30 days", label: "Last 30 days" },
                              { value: "Last 60 days", label: "Last 60 days" },
                              {
                                value: "More than 60 days",
                                label: "More than 60 days",
                              },
                            ]
                        ).map(({ value, label }) => (
                          <MenuItem key={value} value={value}>
                            {label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: "end",
                }}
              >
                <Grid item>
                  {featuresAccess?.downloadTrendPlots && (
                    <StyledButton
                      // onClick={handleOpen}
                      endIcon={null}
                      className={classes.BtnSty}
                    >
                      Download trend plots
                    </StyledButton>
                  )}
                </Grid>

                <Grid item>
                  {deliveryCompletionIndicator &&
                    featuresAccess?.viewAverageOTIFTrend && (
                      <StyledButton
                        // onClick={handleOpen}
                        onClick={handleClick}
                        className={classes.BtnSty}
                        endIcon={null}
                      >
                        Average OTIF trend
                      </StyledButton>
                    )}
                  {!deliveryCompletionIndicator &&
                    featuresAccess?.viewAverageEstimatedOTIFTrend && (
                      <StyledButton
                        // onClick={handleOpen}
                        onClick={handleClick}
                        className={classes.BtnSty}
                        endIcon={null}
                      >
                        Average estimated OTIF trend
                      </StyledButton>
                    )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Divider style={{ marginTop: "1rem" }} />
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            style={{ boxShadow: "none", margin: 0 }}
          >
            <AccordionSummary
              className={classes.accordionSummary}
              // expandIcon={<ExpandMoreIcon />}
            >
              <Grid container style={{ justifyContent: "space-between" }}>
                <Grid item>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                      style={{ marginRight: "8px" }}
                      onClick={() => setExpanded(!expanded)}
                      size="small"
                    >
                      {expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                    </IconButton>
                    <Typography
                      variant="body2"
                      style={{ paddingBottom: "inherit", fontWeight: 600 }}
                    >
                      Quick Summary:
                    </Typography>
                  </div>
                </Grid>
                {otifRange !== "All" && (
                  <Grid item>
                    <Typography
                      variant="caption"
                      color="primary"
                      onClick={() => setOtifRange("All")}
                      className={clsx(
                        classes.dpFlx,
                        classes.algnCntr,
                        classes.pointer,
                        classes.onHvrUndrline
                      )}
                    >
                      Clear Quick Summary
                      <ClearIcon color="primary" style={{ fontSize: 15 }} />
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={3}
                style={{ justifyContent: "space-evenly" }}
              >
                <Block
                  data={{
                    value: "Upto 70",
                    lable: deliveryCompletionIndicator
                      ? "70 OTIF (%)"
                      : "Upto 70 estimated OTIF (%)",
                  }}
                  handleChange={(val) => {
                    setOtifRange(val);
                  }}
                  selectedBlockValue={otifRange}
                  loading={quickSummary.loading}
                  countValue={
                    deliveryCompletionIndicator
                      ? quickSummary.data?.OTIFCountUpto70
                        ? quickSummary.data?.OTIFCountUpto70
                        : 0
                      : quickSummary.data?.estimatedOTIFCountUpto70
                      ? quickSummary.data?.estimatedOTIFCountUpto70
                      : 0
                  }
                />
                <Block
                  data={{
                    value: "70 to 90",
                    lable: deliveryCompletionIndicator
                      ? "70 to 90 OTIF (%)"
                      : "Upto 70 to 90 estimated OTIF (%)",
                  }}
                  handleChange={(val) => {
                    setOtifRange(val);
                  }}
                  selectedBlockValue={otifRange}
                  loading={quickSummary.loading}
                  countValue={
                    deliveryCompletionIndicator
                      ? quickSummary.data?.["OTIFCount70To90"]
                        ? quickSummary.data?.["OTIFCount70To90"]
                        : 0
                      : quickSummary.data?.["estimatedOTIFCount70To90"]
                      ? quickSummary.data?.["estimatedOTIFCount70To90"]
                      : 0
                  }
                />
                <Block
                  data={{
                    value: "90+",
                    lable: deliveryCompletionIndicator
                      ? "90+ OTIF (%)"
                      : "Upto 90+ estimated OTIF (%)",
                  }}
                  handleChange={(val) => {
                    setOtifRange(val);
                  }}
                  selectedBlockValue={otifRange}
                  loading={quickSummary.loading}
                  countValue={
                    deliveryCompletionIndicator
                      ? quickSummary.data?.["OTIFCount90Plus"]
                        ? quickSummary.data?.["OTIFCount90Plus"]
                        : 0
                      : quickSummary.data?.["estimatedOTIFCount90Plus"]
                      ? quickSummary.data?.["estimatedOTIFCount90Plus"]
                      : 0
                  }
                />
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Divider />

          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "end",
                flexDirection: "row",
              }}
            >
              {localStorage.collabType !== "CMO" && (
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                    flexDirection: "column",
                    marginTop: "10px",
                  }}
                >
                  <Grid>
                    <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                      CMO:
                    </Typography>
                  </Grid>

                  <Grid>
                    <FormControl
                      variant="outlined"
                      size="small"
                      style={{ width: "12rem", marginRight: "1rem" }}
                    >
                      <Select
                        multiple
                        fullWidth
                        size="small"
                        variant="outlined"
                        displayEmpty
                        value={
                          SelectedCMOList.length > 0 ? SelectedCMOList : []
                        } // Fix: Ensures correct initial display
                        onChange={handleChangeCMOList}
                        onClose={() => handleSelectChangeListLosesFocus("cmo")}
                        renderValue={(selected) =>
                          selected.length === 0
                            ? "All"
                            : getDisplayCMOFilterValue()
                        }
                      >
                        <MenuItem value="All">
                          <Checkbox
                            checked={
                              SelectedCMOList.length === cmoMemberWithId.length
                            }
                          />
                          <ListItemText primary="All" />
                        </MenuItem>
                        {cmoMemberWithId.map((option) => {
                          return (
                            <MenuItem
                              key={option}
                              value={option.organization_id}
                            >
                              <Checkbox
                                checked={
                                  SelectedCMOList.indexOf(
                                    option.organization_id
                                  ) > -1
                                }
                              />
                              <ListItemText
                                primary={option.organization_name}
                              />
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              {/* ////////////   */}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                    Plant ID:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "12rem", marginRight: "1rem" }}
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={
                        selectedPlantIdList.length > 0
                          ? selectedPlantIdList
                          : []
                      } // Fix: Ensures correct initial display
                      onChange={handleChangePlantIdList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("plantID")
                      }
                      renderValue={(selected) =>
                        selected.length === 0 ? "All" : getDisplayPlantIDValue()
                      }
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedPlantIdList.length === plantList.length
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {plantList.map((option) => (
                        <MenuItem key={option} value={option.plantCode}>
                          <Checkbox
                            checked={
                              selectedPlantIdList.indexOf(option.plantCode) > -1
                            }
                          />
                          <ListItemText primary={option.plantCode} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {localStorage.collabType !== "CMO" &&
                String(localStorage.roleName).toLocaleLowerCase() !==
                  "planner" && (
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: "10px",
                    }}
                  >
                    <Grid>
                      <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                        Planner:
                      </Typography>
                    </Grid>

                    <Grid>
                      <FormControl
                        variant="outlined"
                        size="small"
                        style={{ width: "12rem", marginRight: "1rem" }}
                      >
                        <Select
                          multiple
                          fullWidth
                          size="small"
                          variant="outlined"
                          displayEmpty
                          value={
                            selectedPlannerList.length > 0
                              ? selectedPlannerList
                              : []
                          } // Fix: Ensures correct initial display
                          onChange={handleChangePlannerList}
                          onClose={() =>
                            handleSelectChangeListLosesFocus("planner")
                          }
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "All"
                              : getDisplayPlannerValue()
                          }
                        >
                          <MenuItem value="All">
                            <Checkbox
                              checked={
                                selectedPlannerList.length ===
                                plannerList.length
                              }
                            />
                            <ListItemText primary="All" />
                          </MenuItem>
                          {plannerList.map((option) => {
                            return (
                              <MenuItem key={option} value={option.saasUserID}>
                                <Checkbox
                                  checked={
                                    selectedPlannerList.indexOf(option.saasUserID) >
                                    -1
                                  }
                                />
                                <ListItemText primary={option.name} />
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                )}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  className={classes.search}
                  onClick={handleSaveFilter}
                  style={{
                    borderRadius: "2rem",
                    textTransform: "none",
                    borderRadius: "2rem",
                    fontSize:"16px",
                  }}
                  
                >
                  Save filters
                </Button>
              </Grid>

              {/* Clear filter */}
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="caption"
                  style={{
                    justifyContent: "end",
                    fontSize: "14px",
                    color: "blue",
                    marginLeft: "5px",

                  }}
                  className={classes.clearText}
                  onClick={handleClearFilters}
                >
                  Clear All Filters
                </Typography>
              </Grid>
            </Grid>

            <Grid item>
              <Grid
                container
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                }}
              >
                <Grid
                  item
                  style={{
                    // textDecoration: 'underline',
                    // fontStyle: 'italic',
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{ color: "gray", marginRight: "8px" }}
                    className="last-synced-text"
                  >
                    {`Last synced @ ${moment(new Date()).format(
                      "HH:mm:ss; DD MMMM YYYY"
                    )}`}
                  </Typography>
                  <Grid>
                    <Typography
                      variant="body2"
                      color="primary"
                      style={{
                        textDecoration: "underline",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      className="refresh-button"
                      onClick={handleRefresh}
                    >
                      Refresh
                      <Refresh color="primary" fontSize="small" className="refresh-button" />
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "10px",
                    width: "100%",
                  }}
                  className="per-page-box"
                >
                  <Typography
                    style={{
                      fontWeight: "bold",
                      marginRight: "4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    PER PAGE
                  </Typography>
                  <FormControl variant="outlined" size="small" className="per-page-box">
                    <Select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                    >
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Table */}
          <TableContainer
            style={{ marginTop: "1rem", minHeight: "auto", maxHeight: "400px" }}
            component={Paper}
          >
            <Table stickyHeader className="default-table-styles">
              {/* Table Header */}
              <TableHead>
                <TableRow style={{ backgroundColor: "#F0F0F0" }}>
                  <TableCell style={{ textAlign: "left" }}></TableCell>
                  {localStorage.collabType !== "CMO" ? (
                    <TableCell style={{ textAlign: "left" }}>CMO</TableCell>
                  ) : (
                    <TableCell style={{ textAlign: "left" }}>BMS</TableCell>
                  )}
                  <TableCell style={{ textAlign: "left" }}>PO - Line</TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    Product Code / Description
                  </TableCell>
                  {deliveryCompletionIndicator ? (
                    <TableCell style={{ textAlign: "right" }}>
                      Delivered Quantity
                    </TableCell>
                  ) : (
                    <TableCell style={{ textAlign: "right" }}>
                      Committed Quantity
                    </TableCell>
                  )}
                  <TableCell style={{ textAlign: "left" }}>UoM</TableCell>
                  {deliveryCompletionIndicator ? (
                    <TableCell style={{ textAlign: "left" }}>
                      Delivered Date
                    </TableCell>
                  ) : (
                    <TableCell style={{ textAlign: "left" }}>
                      Committed Date
                    </TableCell>
                  )}

                  {deliveryCompletionIndicator ? (
                    <TableCell style={{ textAlign: "center" }}>
                      OTIF (%)
                    </TableCell>
                  ) : (
                    <TableCell style={{ textAlign: "center" }}>
                      Estimated OTIF (%)
                    </TableCell>
                  )}

                  <TableCell style={{ textAlign: "center" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={12}>
                      <div style={{ textAlign: "center" }}>
                        <CircularProgress color="primary" thickness={7} />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : error ? (
                <TableBody>
                  <TableRow
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <TableCell colSpan={9} align="center">
                      Something went wrong. Please try again later.
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {lineItems?.slDetailsList?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                  {lineItems?.slDetailsList?.map((item, index) => (
                    <>
                      {" "}
                      <TableRow key={`row-${index}`}>
                        {/* Expandable Row Icon */}
                        <TableCell>
                          <IconButton
                            onClick={() => handleRowToggle(index)}
                            size="small"
                          >
                            {open[index] ? (
                              <ExpandMoreIcon />
                            ) : (
                              <ChevronRightIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        {localStorage.collabType !== "CMO" ? (
                          <TableCell>{item.vendorName}</TableCell>
                        ) : (
                          <TableCell>{item.sponsorName}</TableCell>
                        )}

                        <TableCell>{item.poAndLine}</TableCell>
                        <TableCell>{item.productCodeAndName}</TableCell>
                        {deliveryCompletionIndicator ? (
                          <TableCell style={{ textAlign: "right" }}>
                            {item.deliveredQuantity}
                          </TableCell>
                        ) : (
                          <TableCell style={{ textAlign: "right" }}>
                            {item.committedQuantity}
                          </TableCell>
                        )}
                        <TableCell>{item.uom}</TableCell>

                        {deliveryCompletionIndicator ? (
                          <TableCell style={{ textAlign: "left" }}>
                            {item.deliveryDate
                              ? moment(item.deliveryDate).format("DD-MMM-YYYY").toUpperCase()
                              : "NA"}
                          </TableCell>
                        ) : (
                          <TableCell style={{ textAlign: "left" }}>
                            {item.committedDate
                              ? moment(item.committedDate).format("DD-MMM-YYYY").toUpperCase()
                              : "NA"}
                          </TableCell>
                        )}

                        {deliveryCompletionIndicator ? (
                          <TableCell style={{ textAlign: "center" }}>
                            <Chip
                              label={item.OTIFPercentage}
                              style={{
                                backgroundColor: getChipColor(
                                  item.OTIFPercentage
                                ),
                                color: "white",
                                borderRadius: "4px",
                                width: "100%",
                              }}
                            />
                          </TableCell>
                        ) : (
                          <TableCell style={{ textAlign: "center" }}>
                            <Chip
                              label={item.estimatedOTIFPercentage}
                              style={{
                                backgroundColor: getChipColor(
                                  item.estimatedOTIFPercentage
                                ),
                                color: "white",
                                borderRadius: "4px",
                                width: "100%",
                              }}
                            />
                          </TableCell>
                        )}

                        <TableCell style={{ textAlign: "center" }}>
                          <IconButton>
                            <VisibilityIcon
                              onClick={() =>
                                handleOpenCloseDialogBox("detailView", item)
                              }
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={12} style={{ padding: 0 }}>
                          <Collapse
                            in={open[index]}
                            timeout="auto"
                            unmountOnExit
                          >
                            {/* <Box margin={2}>
                            <StatusTab data={item} />
                          </Box> */}
                            <Box margin={2}>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Box
                                  flex={featuresAccess?.chatForPO ? "7" : "10"}
                                  paddingRight={2}
                                >
                                  <StatusTab data={item} />
                                </Box>
                                {/* 30% Box */}
                                {featuresAccess?.chatForPO && (
                                  <Box flex="3">
                                    <POLineChat
                                      poNumber={item.scheduleAgreementNumber}
                                      vendorMosymphonyID={
                                        item.vendorMosymphonyID
                                      }
                                      lineItemNumber={
                                        item.scheduleLineItemNumber
                                      }
                                      schrockenPOLineID={item.schrockenSLID}
                                    />
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}

                  {/* Expandable Content */}
                </TableBody>
              )}

              {/* {error && (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={9} align="center">
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            )} */}
              {/* Table Body */}
            </Table>
          </TableContainer>
          {lineItems?.slDetailsList?.length !== 0 ? (
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              style={{ paddingTop: "1rem" }}
            >
              <PaginationInput
                totalPages={totalPages}
                handlePageChange={handlePageChange}
                page={currentPage}
              />
            </Grid>
          ) : null}
        </Grid>
      </Grid>
      <Dialog open={savedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Filters saved successfully"}
        />
      </Dialog>

      {openDialogBox.detailView && (
        <Dialog open={openDialogBox.detailView} fullScreen>
          <CustomDialogTitle
            onBackClick={() => handleOpenCloseDialogBox("detailView")}
            title={""}
          />
          <DetailView
            data={rowData}
            deliveryCompletionIndicator={deliveryCompletionIndicator}
          />
        </Dialog>
      )}

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
